<template>
  <div>
    <v-layout
      v-if="showHeader"
      class="subheading pt-2"
      align-center
    >
      <v-icon
        class="mr-2"
        medium
        color="msr"
      >
        search
      </v-icon>
      <div>
        {{ $t('menuItemsSearchResults') }} ({{ menuItems.length }})
        <!-- Reset search  -->
        <div
          class="caption msr--text pseudo-anchor--inverted"
          @click="$emit('clear-search')"
        >
          {{ $t('clearSearch') }}
        </div>
      </div>
    </v-layout>
    <v-data-table
      hide-actions
      disable-initial-sort
      :headers="headers"
      :items="menuItems"
      class="menu-items-table"
      :no-data-text="$t('noMenuItemsForSearch')"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :key="props.item.id"
          :title="$t('goToMenuCategoryMenuItems')"
          class="unselectable clickable"
          @click="$emit('search-result-selected', props.item)"
        >
          <!-- Category -->
          <td>
            <v-chip
              label
              class="grey lighten-3 body-1 outlined--dark ma-0 clickable"
            >
              {{ props.item.category.name }}
            </v-chip>
          </td>
          <!-- Name -->
          <td>
            <span class="body-1">{{ props.item.name }}</span>
          </td>
          <!-- Image -->
          <td
            class="clickable unselectable"
            :title="$t('editmenuitem')"
            @click="editMenuItem(props.item)"
          >
            <img
              :src="props.item.image"
              :height="menuItemImageSize"
              style="margin-top: 6px"
            >
          </td>
          <!-- Description -->
          <td class="unselectable">
            <span
              class="caption"
              style="
                display: inline-block;
                white-space: pre-line;
                max-width: 300px;
                max-height: 72px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ props.item.description }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    menuItems: {
      type: Array[Object],
      required: true,
    },
    menuId: {
      type: [Number, String],
      required: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    menuItemImageSize() {
      if (this.$store.state.common.fullscreenMode) {
        return 64;
      }
      return 48;
    },
    headers() {
      return [
        {
          text: this.$t('menuCategory'),
          value: 'category.name',
          sortable: false,
        },
        {
          text: this.$t('menuItem'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('description'),
          value: 'description',
          sortable: false,
        },
        {
          text: this.$t('menuItemImage'),
          value: 'image',
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style scoped>
@media (min-width: 600px) {
  .menu-items-table >>> th,
  td {
    padding: 0 12px !important; /* Half horiz. padding for desktop. */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuItemsSearchResults.vue